import React from 'react';

import { Box, Row } from '@opendoor/atoms/box';
import { OpendoorLogo, OpendoorLogoBadge } from 'components/landing-pages-v2/shared/OpendoorLogo';

export const LogoSection: React.FC = () => {
  return (
    <Row className="z-[5] col-start-1 col-end-2 row-start-1 row-end-2 items-center pr-2">
      <Box
        href="/"
        analyticsName="cosmos-logo-link"
        aria-label="Go to Home page"
        className="flex items-center text-od-content-primary max-md:hidden"
      >
        <OpendoorLogo width="96px" />
      </Box>
      <Box
        href="/"
        analyticsName="cosmos-logo-link"
        aria-label="Go to Home page"
        className="flex items-center text-od-content-primary md:hidden"
      >
        <OpendoorLogoBadge />
      </Box>
    </Row>
  );
};
